import React, { useState } from "react";
import "./Counselling.css";
import CounsellingForm from "./CounsellingForm";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Counselling = () => {
  const [showForm, setShowForm] = useState(false);

  const handleSuccess = () => {
    toast.success("Appointment successfully booked!");
    setShowForm(false);
  };

  return (
    <div className="counselling-page">
      <h1>1-to-1 Counselling with Navveer Foundation</h1>
      <p>Personalized support and guidance for your journey</p>

      <ul className="features-list">
        <li>🧑‍🏫 1-to-1 Dedicated Counsellor</li>
        <li>💸 100% Free of Cost</li>
        <li>🎯 Future & Career Guidance</li>
        <li>🎓 Qualified & Experienced Counsellors</li>
        <li>🕊️ Safe and Confidential Sessions</li>
        <li>📅 Flexible Scheduling</li>
      </ul>

      <button className="book-btn" onClick={() => setShowForm(true)}>
        Book Free Appointment
      </button>

      {showForm && <CounsellingForm onClose={() => setShowForm(false)} onSuccess={handleSuccess} />}

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default Counselling;
